import ecFlowService from './ecFlowService';
import ecPushRegistry from './ecPushRegistry';

const observe = ({messageId, notificationSubType} = {}) => {
    if (!messageId || !ecPushRegistry.isEcSubType(notificationSubType)) return;

    ecFlowService.startFlow(messageId);
    ecPushRegistry.add({messageId, notificationSubType});
};

export default {
    observe,
};
